var map = {
	"./0.png": 125,
	"./1.png": 126,
	"./10.png": 127,
	"./11.png": 128,
	"./12.png": 129,
	"./13.png": 130,
	"./2.png": 131,
	"./3.png": 132,
	"./4.png": 133,
	"./5.png": 134,
	"./6.png": 135,
	"./7.png": 136,
	"./8.png": 137,
	"./9.png": 138
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 556;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg ^\.\/.*\.png$
// module id = 556
// module chunks = 2